<template>
  <div class="task-attendance_wrapper">
    <div class="task-attendance_field-item">
      <div class="d-flex align-items-center ">
        <img class="task-icon mr-1" :src="vipIcon" />
        <span>{{ taskInfo.custName }}</span>
      </div>
    </div>
    <div class="task-attendance_field-item">
      <div class="d-flex align-items-center ">
        <img class="task-icon mr-1" :src="shopIcon" />
        <span>{{ taskInfo.expoInfoName }}</span>
      </div>
    </div>
    <div class="task-attendance_field-item mt-3">
      <div class="task-attendance_field-item_label">
        <span> {{ $l('table_field_manager') || '经办人' }}：</span>
      </div>
      <div class="task-attendance_field-item_value">
        <div class="d-flex align-items-center">
          <div class="task-attendance_field-item_value_img mr-2">
            <img :src="taskInfo.tskByMemImgUrl || DefMemIcon" />
          </div>
          <span>{{ taskInfo.tskByName }}</span>
        </div>
      </div>
    </div>
    <div class="task-attendance_field-item">
      <div class="task-attendance_field-item_label">
        <span> {{ $l('table_field_report') || '报告人' }}： </span>
      </div>
      <div class="task-attendance_field-item_value">
        <div class="d-flex align-items-center">
          <div class="task-attendance_field-item_value_img mr-2">
            <img :src="taskInfo.createByMemImgUrl || DefMemIcon" />
          </div>
          {{ taskInfo.createByName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const DefMemIcon = require('../../../components/images/def-mem.png')
const vipIcon = require('../../../components/images/vip.png')
const shopIcon = require('../../../components/images/shop.png')
export default {
  props: { taskInfo: { type: Object, default: () => {} } },
  data() {
    return {
      DefMemIcon,
      vipIcon,
      shopIcon,
    }
  },
  methods: {
    convertsArrayString(str) {
      if (!str) return ''
      const data = JSON.parse(str)
      return data.join(' / ')
    },
  },
}
</script>

<style lang="scss" scoped>
.task-attendance_wrapper {
  height: 150px;
  overflow: auto;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.task-attendance_field-item_value_img {
  width: 25px;
  height: 25px;
  > img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}

.task-attendance_field-item {
  display: flex;
  font-size: 14px;
  .task-attendance_field-item_label {
    color: #4f4f4f;
    width: 100px;
  }
  .task-attendance_field-item_value {
    color: #6c757d;
  }
  .task-icon {
    width: 24px;
    height: 24px;
  }
}
.meeting_no {
  color: #6c6c6c;
  font-size: 14px;
}
.task-attendance_wrapper::-webkit-scrollbar-track {
  background: #eee; /* 滚动条轨道颜色 */
  border-radius: 5px; /* 滚动条轨道圆角 */
}
.task-attendance_wrapper::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.task-attendance_wrapper::-webkit-scrollbar-thumb {
  background: #ccc; /* 滚动条thumb颜色 */
  border-radius: 5px; /* 滚动条thumb圆角 */
}
</style>
